import { Dimension } from "@/services/dimension/dimension.model"
import { InputNumber, Select, Space } from "antd"
import styles from './index.module.less'
import Title from "antd/es/typography/Title"
import { useEffect, useState } from "react"

export interface UnitVal {
  dim: number
  unit: number
  format: string
  digits: number
  cutoff: number
}

export interface UnitRowProps {
  dim: Dimension.Info
  value?: UnitVal
  onChange?: (value: UnitVal) => void
}

export const UnitRow: React.FC<UnitRowProps> = ({ value: initVal, onChange, dim }) => {

  const [value, setValue] = useState(initVal || {dim: dim.id} as UnitVal)

  useEffect(() => {
    if (initVal) {
      setValue(initVal)
    }
  }, [initVal, setValue])

  const onItemChange = (key: string, itemVal: any) => {
    const newVal = {...value, [key]: itemVal}
    setValue(newVal)
    onChange?.(newVal)
  }

  return <div>
    <Title level={5}>{dim.code}</Title>
    <Space>
    <Space className={styles.rowItem}>
      <div>Unit:</div>
      <Select
        style={{width: 220}}
        value={value?.unit}
        onChange={(val) => onItemChange('unit', val)}
        options={dim.units.map((item) => ({ label: item.code, value: item.id }))}></Select>
    </Space>
    <Space className={styles.rowItem}>
      <div>Format:</div>
      <Select style={{width: 220}}
        onChange={(val) => onItemChange('format', val)}
        value={value?.format}>
        {['CONV', 'SN', 'SF'].map((item) => (
          <Select.Option key={item} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Space>
    {/* <Space className={styles.rowItem}>
      <div>Digits:</div>
      <InputNumber onChange={(val) => onItemChange('digits', val)} style={{ width: 100 }} value={value?.digits} />
    </Space> */}
    <Space className={styles.rowItem}>
      <div>Cutoff:</div>
      <InputNumber onChange={(val) => onItemChange('cutoff', val)} min={0} style={{ width: 160 }} value={value?.cutoff} />
    </Space>
    </Space>
  </div>
}   